module.exports = __webpack_public_path__ + "img/edit-blue.7e190529.svg";